export const ptBRHouseholdItems = {
  assigneeLabel: 'Responsável: ',
  dueLabel: 'Vencimento: ',
  edit: 'Editar',
  delete: 'Excluir',
  stateOpen: 'Aberto',
  stateDone: 'Concluído',
  hasPictureLabel: 'Tem uma foto',
  typeListItem: 'Item de lista',
  typeChore: 'Afazer',
  typeTask: 'Tarefa',
  toastCreated: 'Item criado',
  toastUpdated: 'Item atualizado',
  toastDeleted: 'Item excluído',
  toastToggled: 'Item atualizado',
  toastCreatedError: 'Falha ao criar item',
  toastUpdatedError: 'Falha ao atualizar item',
  toastDeletedError: 'Falha ao excluir item',
  toastToggledError: 'Falha ao atualizar item',
} as const;
